import { render } from "./UserSeeds.vue?vue&type=template&id=e8da1ab0"
import script from "./UserSeeds.vue?vue&type=script&lang=js"
export * from "./UserSeeds.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\beam\\Project\\DAPPS\\beam-dapps\\nft_gallery_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__